class Input
    constructor: (el) ->
        @.$el = el
        if !@.$el.classList.contains 'input--bound'
            @.$errorEl = @.$el.querySelector '.input__error'
            @.$inputEl = @.$el.querySelector '.input__input'
            @.$inputInputEl = @.$el.querySelector '.input__input-field'
            @.$maxFileSizeInputEl = @.$el.querySelector 'input[name="MAX_FILE_SIZE"]'
            @.$textareaEl = @.$el.querySelector '.input__textarea'
            @.$textareaInputEl = @.$el.querySelector 'textarea'

            @.disabled = @.$el.classList.contains 'input--disabled'
            @.error = @.$el.classList.contains 'input--error'
            @.maxFileSize = if @.$maxFileSizeInputEl then parseInt(@.$maxFileSizeInputEl.value,10) else false
            @.maxFileSizeText = @.$el.dataset?.mfsText ? 'Die Datei konnte nicht hinzugefügt werden, da sie zu groß ist.'
            @.required = @.$el.classList.contains 'input--required'
            @.requiredText = @.$el.dataset?.requiredText ? 'Dieses Feld muss ausgefüllt werden.'
            @.type = @.$el.dataset?.type ? 'text'

            @.$el.classList.add 'input--bound'
            @.InitEvents()
        return

    InitEvents: ->
        self = @
        @.$el.addEventListener 'input-reset', (e) ->
            self.Reset()
            return
        @.$el.addEventListener 'input-set-error', (e) ->
            showError = e.detail?.showError ? false
            errorText = e.detail?.errorText ? self.requiredText
            if showError
                self.SetError errorText
            else
                self.SetError false
            return
        if @.type == 'textarea'
            if @.$textareaEl && @.$textareaInputEl
                @.$textareaEl.addEventListener 'input', (e) ->
                    self.SetError false
                    if !self.disabled
                        text = @.textContent
                        self.$textareaInputEl.value = text
                        if text != ""
                            @.classList.add 'input__textarea--filled'
                        else
                            if self.required
                                self.SetError self.requiredText
                            @.classList.remove 'input__textarea--filled'
                    return
        else 
            if @.type == 'file'
                if @.$inputEl
                    @.$inputEl.addEventListener 'click', (e) ->
                        if !self.disabled
                            self.$inputInputEl.click()
                        return
            if @.type != 'hidden'
                if @.$inputInputEl
                    @.$inputInputEl.addEventListener 'input', (e) ->
                        if !self.disabled
                            self.SetError false
                            if self.type == 'file'
                                if @.value != ""
                                    fileNames = []
                                    for file in @.files
                                        if self.maxFileSize
                                            if file.size <= self.maxFileSize
                                                fileNames.push file.name
                                            else
                                                @.value = ""
                                                self.SetError self.maxFileSizeText
                                        else
                                            fileNames.push file.name
                                    if self.$inputEl
                                        self.$inputEl.innerHTML = fileNames.join ', '
                                        self.$inputEl.classList.add 'input__input--filled'
                                else
                                    if self.$inputEl
                                        self.$inputEl.innerHTML = ""
                                        self.$inputEl.classList.remove 'input__input--filled'
                                        if self.required
                                            self.SetError self.requiredText
                            else
                                if @.value != ""
                                    @.classList.add 'input__input--filled'
                                else
                                    if self.required
                                        self.SetError self.requiredText
                                    @.classList.remove 'input__input--filled'
                        return
        return
    
    Reset: ->
        if @.type == "textarea"
            @.$textareaEl.textContent = ""
            @.$textareaEl.classList.remove 'input__textarea--filled'
            @.$textareaInputEl.value = ""
        else
            if @.type == "file"
                @.$inputEl.innerHTML = ""
                @.$inputEl.classList.remove 'input__input--filled'
            @.$inputInputEl.value = ""
            @.$inputInputEl.classList.remove 'input__input--filled'
        @.SetError false
        return
    
    SetError: (error) ->
        if error && error != ''
            @.$errorEl.innerHTML = error
            @.$el.classList.add 'input--error'
            @.error = true
        else
            @.$errorEl.innerHTML = ""
            @.$el.classList.remove 'input--error'
            @.error = false
        return

BindInputs = ->
    document.querySelectorAll '.input:not(.input--bound)'
        .forEach (el) ->
            new Input el
            return
    return

window.addEventListener 'bind-components', BindInputs